<template>
    <div class="tCenteredArea_Easy" id="vue-tinder-Easy">

        <Accordion v-model:value="accordion_value" id="vue-tinder-accordion">
            <AccordionPanel value="0">
            </AccordionPanel>
            <AccordionPanel value="1">
                <AccordionHeader>{{ $t('filters.filters') }}</AccordionHeader>
                <AccordionContent>
                    <div class="filters d-flex flex-column align-items-start justify-content-center">
                        <div class="filter">
                            <label for="age">{{ $t('filters.gender') }}</label>
                            <MultiSelect v-model="selectedGender" :options="genders" optionLabel="name" optionValue="id"
                                :placeholder="$t('filters.placeholder')" :maxSelectedLabels="3" fluid  />
                        </div>
                        <div class="filter">
                            <label for="age">{{ $t('filters.age') }}</label>
                            <MultiSelect v-model="selected_age" :options="ages" optionLabel="name" optionValue="id"
                                :placeholder="$t('filters.placeholder2')" :maxSelectedLabels="3" class="w-full " />
                        </div>
                        <Button :label="$t('filters.start')" icon="pi pi-check" iconPos="right" @click="startMatches"
                            size="small" class="start-btn" />

                    </div>
                </AccordionContent>
            </AccordionPanel>

        </Accordion>

        <div id="tMatches_Easy-tinder-container">

            <div v-if="queue.length == 0">
                <div class="no_matches">
                    <span>{{ $t('matches.no_matches') }}</span>
                </div>
            </div>

            <Tinder ref="tinder" key-name="_id" v-model:queue="queue" :max="5" :offset-y="-5" :allow-down="false"
                @submit="onSubmit" v-if="queue.length > 0">
                <template #default="{ data }">
                    <div class="pic" :style="{ 'background-image': `url(${data.avatar})` }" />
                    <div class="name">{{ data.nickname }}</div>
                </template>
                <template #like>
                    <span class="like-pointer span_badge"> {{ $t('matches.like') }}</span>
                </template>
                <template #nope>
                    <span class="nope-pointer span_badge"> {{ $t('matches.nope') }}</span>
                </template>
                <template #super>
                    <span class="super-pointer span_badge"> {{ $t('matches.message') }}</span>
                </template>
                <template #down>
                    <span class="down-pointer span_badge"> {{ $t('matches.later') }}</span>
                </template>
                <template #rewind>
                    <span class="rewind-pointer span_badge"> {{ $t('matches.rewind') }}</span>
                </template>
            </Tinder>
        </div>

        <div class="btns" v-if="queue.length > 0">
            <img src="https:///cdn1.easychatrooms.com/assets/images/nope.png" @click="decide('nope')" />
            <img src="https:///cdn1.easychatrooms.com/assets/images/send-message.png" @click="decide('super')" />
            <img src="https:///cdn1.easychatrooms.com/assets/images/like.png" @click="decide('like')" />
        </div>

    </div>
</template>

<script>
import Tinder from './vue-tinder/Tinder.vue'

export default {
    name: 'App',
    components: { Tinder },
    data: () => ({
        accordion_value: '0',
        selectedGender: (localStorage.getItem('selectedGender') ? localStorage.getItem('selectedGender').split(',').map(Number).filter(item => Number.isInteger(item) && item !== 0) : []),
        selected_age: (localStorage.getItem('selected_age') ? localStorage.getItem('selected_age').split(',').map(Number).filter(item => Number.isInteger(item) && item !== 0) : []),
        queue: [],
        offset: 0,
        history: [],
        ages: [
            { id: 1, name: '18-25' },
            { id: 2, name: '25-35' },
            { id: 3, name: '35-45' },
            { id: 4, name: '45-55' },
            { id: 5, name: '55-65+' },
        ]
    }),
    created() {
        if (this.selectedGender.length === 0 && this.selected_age.length === 0) {
            this.accordion_value = '1'
        }
    },

    mounted() {
        this.$socket.on('matching_list', (data) => {
            if (data.length > 0) {
                this.queue = data
            }
            this.accordion_value = '0';
        })
        if (this.selectedGender.length !== 0) {
            this.startMatches()
        }
    },
    unmounted() {
        this.$socket.off('matching_list')
    },

    computed: {
        genders() {
            return this.$tm('genders');
        },
    },
    methods: {
        startMatches() {
            localStorage.setItem('selectedGender', this.selectedGender);
            localStorage.setItem('selected_age', this.selected_age);
            if (this.selectedGender.length == 0) {
                return;
            }

            this.$socket.emit('getMatching', { genders: this.selectedGender, ages: this.selected_age });
        },
        onSubmit(choice) {
            if (choice.type == 'super') {
                this.$emit('selectMenu', { action: 'message', user: { user_id: choice.item._id, nickname: choice.item.nickname, avatar: choice.item.avatar } });
            } else if (choice.type == 'nope') {
                //this.$socket.emit('like', choice.id);
            } else if (choice.type == 'like') {
                this.$emit('selectMenu', { action: 'addFollow', user: { user_id: choice.item._id } });
            }
            this.$socket.emit('addMatched', { target: choice.item._id });
            if (this.queue.length == 0) {
                setTimeout(() => {
                    this.startMatches();
                }, 3000);

            }
        },
        async decide(choice) {
            this.$refs.tinder.decide(choice);
        }
    }
}
</script>

<style>
#tMatches_Easy-tinder-container {
    height: 100%;
    position: relative;
}

#vue-tinder-accordion {
    max-width: 582px;
    margin: auto;
}

.filters {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    align-items: end;
}

.start-btn {
    height: 36px;
}

#vue-tinder-Easy {
    position: relative;
    height: calc(100% - 55px);
}

#vue-tinder-Easy .vue-tinder {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 23px;
    margin: auto;
    width: calc(100% - 20px);
    height: calc(100% - 23px - 65px - 47px - 56px);
    max-height: 617px;
    min-width: 300px;
    max-width: 355px;
}


.span_badge {
    font-size: 24px;
}

.like-pointer {
    color: #1de3a0;
}

.nope-pointer {
    color: #f13b2d;
}

.super-pointer {
    color: #086184;
}

.down-pointer {
    color: #962df1;
}

.nope-pointer,
.like-pointer {
    position: absolute;
    z-index: 1;
    top: 20px;
    width: 64px;
    height: 64px;
}

.nope-pointer {
    right: 10px;
}

.like-pointer {
    left: 10px;
}

.super-pointer,
.down-pointer {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    margin: auto;
    width: 112px;
    height: 78px;
}

.super-pointer {
    bottom: 40px;
}

.down-pointer {
    top: 40px;
}

.rewind-pointer {
    position: absolute;
    z-index: 1;
    top: 20px;
    right: 10px;
    width: 112px;
    height: 78px;
}

.pic {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
}

.btns {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 30px;
    margin: auto;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 300px;
    max-width: 355px;
}

.btns img {
    margin-right: 12px;
    box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.btns img:nth-child(2n + 1) {
    width: 53px;
}

.btns img:nth-child(2n) {
    width: 65px;
}

.btns img:nth-last-child(1) {
    margin-right: 0;
}

.name {
    position: absolute;
    width: 100%;
    background: #c5c5c59c;
    bottom: 0;
    padding: 12px;
    font-size: 16px;
    font-weight: bolder;
}

.no_matches {
    text-align: center;
    margin: 40px;
    font-size: 24px;
}

/* .vue-tinder.right-end,
  .vue-tinder.left-end {
    transform: translateZ(20px);
  }
  .vue-tinder.right-end .tinder-card:nth-child(1) {
    animation: rightEnd 0.2s ease-in-out;
  }
  .vue-tinder.left-end .tinder-card:nth-child(1) {
    animation: leftEnd 0.2s ease-in-out;
  }
  @keyframes leftEnd {
    50% {
      transform: rotateY(8deg);
    }
  }
  @keyframes rightEnd {
    50% {
      transform: rotateY(-8deg);
    }
  } */
</style>
